$.fn.exportToDapOnClick = function () {
  // Button using this hidden in DEL-4377
  var DCLG = window.DCLG;
  var $DIALOG;
  var URLS = {};

  this.each(function () {
    var $self = $(this);

    if ($self.attr("href")) {

      // Dialog INIT
      if ($self.data("validate") === true) {
        // Init dialog popup
        $DIALOG = buildDialog({
          id: "export-dap-dialog",
          title: "Please note",
          buttons: [
            { type: "cancel", text: "No", extraClasses: "button-grey" },
            { type: "proceed", text: "Yes", extraClasses: "button" },
          ],
          buttonsAlign: "",
          colorScheme: "warning",
        });

        // Event handler for when confirmation dialog is used
        $("body").on("dialog.close.exportdap", $DIALOG, closeDialog);
      }

      $self.on("click", function (event) {
        event.preventDefault();

        clearMessageInPage();


        URLS.destU = $self.attr("href");
        URLS.valU = URLS.destU;
        //                URLS.valU = '/submissions/allow-download.json';
        var baseUrl = "/submissions/datastore/getExportTime";

        var sym = URLS.destU.indexOf("?") === -1 ? "?" : "&";

        var queryParams = DCLG.DataGrid.instance.dclg.params;
        if (!$.isEmptyObject(queryParams)) {
          URLS.destU = URLS.destU + sym + $.param(queryParams);
          URLS.valU += "?" + $.param(queryParams);
          baseUrl += "?" + $.param(queryParams);
        }


        var dateTime = "";

        $.ajax({
          dataType: "JSON",
          url: baseUrl,
        })
          .done(function (response) {
            if (response["data-export"]["date"] != undefined) {
              dateTime = new Date(
                response["data-export"]["date"].replace("Z", ""),
              );
              var year = dateTime.getFullYear();
              var month = dateTime.getMonth();
              var day = dateTime.getDate() - 1;
              var time = dateTime.toLocaleTimeString();

              var dateOrTime =
                ("0" + dateTime.getDate()).slice(-2) +
                "/" +
                ("0" + (dateTime.getMonth() + 1)).slice(-2) +
                "/" +
                year +
                " - " +
                time;
              var extractedDate = new Date(year, month, day);
              var currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);

              if (currentDate.getTime() === extractedDate.getTime()) {
                var tempDate = new Date();
                if (
                  dateTime.getHours == tempDate.getHours() &&
                  dateTime.getMinutes() - tempDate.getMinutes() < 5
                ) {
                  showDialog(
                    "A request has recently been made on this dataset/instance. Please check that you do require a fresh export and wait 5 minutes after the time above",
                  );
                }
              } else {
                showDialog(
                  "This will export all data changes made since " +
                    dateOrTime +
                    " to the DAP - are you sure you wish to proceed?",
                );
              }
            } else {
              showDialog(
                "This will export your data to the DAP - are you sure you wish to proceed?",
              );
            }
          })
          .fail(function (response) {
            /*var jsonResponse = {"data-export":{
                    "uris": "/",
                    "date": "2019-11-25T23:59:59.999Z",
                    "type": "jabajaba",
                    "zip-uri": "jabajaba"
                    }}*/
            showDialog(
              "This will export your data to the DAP - are you sure you wish to proceed?",
            );
          });
      });
    }
  });

  function redirectTo(u) {
    window.location.href = u;
    //          console.log('redirecting to url : '+u)
  }

  function buildDialog(builder) {
    var $dialog = $("#" + builder.id);

    if ($dialog) {
      // Title
      $dialog.find(".dialog-title").text(builder.title);

      // Buttons
      $.each(builder.buttons, function () {
        $dialog
          .find(".dialog-buttons button.dialog-" + this.type)
          .text(this.text)
          .addClass(this.extraClasses);
      });

      // Color Scheme
      $dialog
        .find(".icon.fa")
        .removeClass("fa-icontype")
        .addClass("fa-" + builder.colorScheme);

      // Event Handler for button-clicks
      $dialog.find(".dialog-buttons button").on("click", function (e) {
        e.preventDefault();

        // Event trigger for closing the dialog
        $dialog.trigger("dialog.close.exportdap", {
          button: e.target,
          destU: URLS.destU,
        });
      });
    }

    return $dialog;
  }

  function clearMessageInPage() {
    $("#message p").text("");
  }

  function showMessageInPage(msgType, msg) {
    var msgStyleColor = {};
    // Set CSS styles
    switch (msgType.toLowerCase()) {
      case "info":
        msgStyleColor.color = "blue";
      case "success":
        msgStyleColor.color = "green";
      case "warning":
        msgStyleColor.color = "orange";
      case "error":
      default:
        msgStyleColor.color = "red";
    }
    // Apply CSS style
    $("#message p").css(msgStyleColor).text(msg);
  }

  function closeDialog(e, trigger) {
    e.preventDefault();

    // Close the dialog
    e.target.close();

    // Remove indicators which show the dialog as being 'open'
    $("body").removeClass("dialog-is-open");

    // Decide whether to honour the DownloadCSV request, based on user feedback
    if ($(trigger.button).hasClass("dialog-proceed")) {
      console.log(
        "You chose to PROCEED with your Download*** request",
        trigger,
      );
      redirectToDownload(trigger.destU);
    } else {
    }
  }

  function isInDataStorePage() {
    return $("#datastore-page").length > 0;
  }

  function isInTestDataStorePage() {
    return $("#test-datastore-page").length > 0;
  }

  function redirectToDownload(url) {
    var token = $("#_csrf").val();
    if (isInDataStorePage() || isInTestDataStorePage()) {
      $.ajax({
        type: "POST",
        dataType: "JSON",
        url: url,
        beforeSend: function (xhr) {
          xhr.setRequestHeader("X-CSRF-TOKEN", token);
        },
        // data: URLS.data
      })
        .done(function (response) {
          $("#message").text("Your export has been queued");
          //                                         redirectTo('/submissions/data-store');
          //                                         else $('#message').text(response.message.value);
        })
        .fail(function (response) {
          $("#message").text("");
          setError(
            "This dataset is not enabled to export to DAP, please speak to a Delta administrator",
          );
        });
    }
    //                            else redirectTo(url);
  }

  function setError(error) {
    $("#error").text(error);
    $("#errorBlock").removeClass("visually-hidden");
  }
  function showDialog(message) {
    // Add dialog message
    $DIALOG.find(".dialog-message").text(message);

    // Include indicators to show the dialog as being 'open'
    $("body").addClass("dialog-is-open");

    //  Now show the dialog...
    $DIALOG[0].showModal();
  }
};
